import React from 'react'
import ReactDOM from 'react-dom'
import 'semantic-ui-css/semantic.min.css'
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
import Root from './views/Root'
import configureStore from './config/configureStore'
import registerServiceWorker from './registerServiceWorker'
import './css/main.css'
import { saveState } from './config/localStorage'

const store = configureStore()

store.subscribe(() => {
  saveState({
    global: store.getState().global,
  })
})

ReactDOM.render(
  <Root store={store} />,
  document.getElementById('root'))
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js